export default __webpack_public_path__ + "static/media/flowchart.b1bb7a8e.jpg";